import { render, staticRenderFns } from "./NavComponent.vue?vue&type=template&id=0210a24a&scoped=true&"
import script from "./NavComponent.vue?vue&type=script&lang=ts&"
export * from "./NavComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NavComponent.vue?vue&type=style&index=0&id=0210a24a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0210a24a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/admin/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0210a24a')) {
      api.createRecord('0210a24a', component.options)
    } else {
      api.reload('0210a24a', component.options)
    }
    module.hot.accept("./NavComponent.vue?vue&type=template&id=0210a24a&scoped=true&", function () {
      api.rerender('0210a24a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NavComponent.vue"
export default component.exports